import { onAuthStateChanged } from 'firebase/auth'
import store from '../store/index'
import router from '../router'
import { HAD_SESSION_KEY } from '../store/modules/auth'

let knownUid = null
let initialized = false

const logEvent = (eventName, eventProperties) => {
  store.dispatch('analytics/logEvent', { eventName, eventProperties })
}

// Следит за сменой firebase-сессии (она общая для всех вкладок браузера через
// IndexedDB): если в другой вкладке разлогинились или вошли под другим
// пользователем, эта вкладка сбрасывается — иначе её «протухший» UI продолжит
// исполнять действия под чужой сессией (web-only, в Cordova одна webview).
// Заодно телеметрия расхода СМС: восстановилась ли сессия на старте и не
// пропала ли она на ходу (наш auth/signOut снимает HAD_SESSION_KEY заранее,
// поэтому сюда попадают только внезапные потери - SDK разлогинил сам)
export default function initSessionWatcher() {
  onAuthStateChanged(store.state.auth.firebaseAuth, (user) => {
    const newUid = user ? user.uid : null

    // Первое событие на старте вкладки — просто запоминаем текущее состояние
    if (!initialized) {
      initialized = true
      knownUid = newUid
      if (newUid) {
        localStorage.setItem(HAD_SESSION_KEY, 'true')
        logEvent('re_auth_session_restored')
      } else if (localStorage.getItem(HAD_SESSION_KEY) === 'true') {
        // Сессия была, но SDK не смог её восстановить (хранилище/ревокация).
        // Логируем один раз: первая вкладка снимает флаг
        localStorage.removeItem(HAD_SESSION_KEY)
        logEvent('re_auth_session_lost', { reason: 'STARTUP' })
      }
      return
    }

    if (newUid === knownUid) {
      return
    }
    knownUid = newUid

    if (newUid) {
      localStorage.setItem(HAD_SESSION_KEY, 'true')
    } else if (localStorage.getItem(HAD_SESSION_KEY) === 'true') {
      logEvent('re_auth_session_lost', { reason: 'RUNTIME' })
      localStorage.removeItem(HAD_SESSION_KEY)
    }

    // Активная вкладка в auth-флоу (/signin: обычный вход, impersonate)
    // сама управляет сессией — не вмешиваемся
    if (router.currentRoute.meta.requiresAuth === false) {
      return
    }
    if (!store.state.auth.user) {
      return
    }

    // Жёсткая перезагрузка: полностью сбрасывает in-memory store (полного
    // reset у vuex-модулей нет). Роутер-гвард на '/' сам решит: есть новая
    // сессия — войдёт под ней, нет — отправит на /signin
    window.location.href = '/'
  })
}
